import { differenceInDays } from 'date-fns'
import { IStore } from '../../index'

export default function(state: IStore) {
  return (
    Math.abs(differenceInDays(state.userAccount.user.serverTime, new Date())) <
    1
  )
}
